import React from 'react';
import { withPrefix } from 'gatsby';
import cx from 'clsx';
import { Ph } from '@rasahq/react-tabula/helpers';

import headerShapes from 'src/assets/vector/header-shapes.svg';
import rdsLogotype from 'src/assets/vector/rs-logotype.svg';

import { HubspotLoader, HubspotForm } from 'src/components/hubspot-form';

import './hero-header.scss';

export default function HeaderSection(section) {
  const { image } = section;
  const regCTA = section.ctas[0];
  return (
    <>
      <nav className="header-nav frame wrap-last chain-s py-s f-mono-s fw-bold">
        <a href="/">
          <span className="v-a11y">Rasa Developer Summit 2021</span>
          <div style={{ width: '170px' }}>
            <div style={{ paddingBottom: '21.7647059%', position: 'relative', height: '30px' }}>
              <img
                src={rdsLogotype}
                alt=""
                style={{ position: 'absolute', top: 0, left: 0, width: '100%' }}
              />
            </div>
          </div>
        </a>
      </nav>
      <header className="clip">
        <div className="frame wrap-last py-m">
          <div className="flow-grid cols-1 ml__cols-2">
            <div className="stack-l">
              <h1 className="v-a11y">{section.heading}</h1>
              <div style={{ position: 'relative', maxWidth: '75%' }}>
                <Ph aspect={image.width / image.height} bg="transparent">
                  <img src={image.url} alt="" style={{ position: 'absolute', top: 0, left: 0 }} />
                </Ph>
              </div>
              {section.contentNode && (
                <div
                  className="prose-mono-m"
                  dangerouslySetInnerHTML={{ __html: section.contentNode.childMarkdownRemark.html }}
                />
              )}
              <div className="shim-xl">
                <HubspotLoader>
                  <HubspotForm formId="b4463a11-e6e8-4605-a529-56aa7bca3bd4" />
                </HubspotLoader>
              </div>
            </div>
            <div className="header-bg-img-outer order-neg-1 ml__order-0 pos-abs ml__pos-rel">
              <div className="header-bg-img-inner">
                <Ph aspect={844 / 663} bg="transparent">
                  <img src={headerShapes} alt="" style={{ position: 'absolute', top: 0, left: 0 }} />
                </Ph>
              </div>
            </div>
          </div>
        </div>
        <div style={{ overflow: 'hidden' }}>
          <svg
            preserveAspectRatio="none"
            viewBox="0 0 1200 120"
            xmlns="http://www.w3.org/2000/svg"
            style={{
              fill: 'var(--color-haiti)',
              width: '100%',
              height: 80,
              transform: 'rotate(180deg) scaleX(-1)',
            }}
          >
            <path d="M1200 120L0 16.48V0h1200v120z" />
          </svg>
        </div>{' '}
      </header>
    </>
  );
}
